import { render, staticRenderFns } from "./PurchaseNew.vue?vue&type=template&id=eb1a2a60&scoped=true"
import script from "./PurchaseNew.vue?vue&type=script&lang=js"
export * from "./PurchaseNew.vue?vue&type=script&lang=js"
import style0 from "./PurchaseNew.vue?vue&type=style&index=0&id=eb1a2a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1a2a60",
  null
  
)

export default component.exports